import css from './index.module.css'
import { ComponentChildren } from 'preact'

const ShadowText = ({ children }: { children: ComponentChildren }) => {
  return <div className={css.info}>{children}</div>
}
export default ShadowText
